module.exports = __webpack_public_path__ + "img/Moster Awaken.19d05c70.jpg";